import apiClient from './apiClient';

export default {
  getUserSettings: () => apiClient.get('/profile/settings'),
  updateUserSettings: (settings) => apiClient.put('/profile/settings', settings),
  updateBillingInfo: (payload) => apiClient.put('/profile/billing_info', payload),
  increaseBillingThreshold: (billingThreshold) => apiClient.put('/profile/billing-threshold', { billing_threshold: billingThreshold }),
  getAPIToken: () => apiClient.get('/profile/api-token'),
  createAPIToken: () => apiClient.put('/profile/api-token'),
  revokeAPIToken: () => apiClient.delete('/profile/api-token'),
  updateGodMode: (email) => apiClient.put('/profile/god-mode', { email } ),
  removeAndBlockUserByIP: (email) => apiClient.put('/profile/remove-and-block', { email } ),
  unsuspendUser: (email) => apiClient.put('/profile/unsuspend', { email }),
  applyPromotionCode: (code) => apiClient.put('/profile/apply-promotion-code', { code }),
  fetchIntegrations: () => apiClient.get('/profile/integrations'),
  updateIntegrations: (integrations) => apiClient.put('/profile/integrations', integrations),
  removeIntegration: (integration) => apiClient.delete(`/profile/integrations/${integration}`),
  connectHubSpot: (code) => apiClient.put('/profile/connect-hubspot', { code }),
  connectZoho: (code, region) => apiClient.put('/profile/connect-zoho', { code, region }),
  connectPipedrive: (code) => apiClient.put('/profile/connect-pipedrive', { code }),
  connectGoogle: (payload) => apiClient.put('/profile/connect-google', payload),
  connectSFTP: (payload) => apiClient.put('/profile/connect-sftp', payload),
  featureRequest: (body, bug) => apiClient.post('/profile/feature-request', { body, bug }),
  getAuthToken: (payload) => apiClient.post('/auth/token', payload),
  refreshAuthToken: (token) => apiClient.put('/auth/token', { access_token: token }),
  authPartnerRedirectToken: (token) => apiClient.post('/auth/partner-token', { token }, { skipAuthRedirect: true, preserveErrorMessage: true }),
  requestPasswordChange: (email) => apiClient.post('/profile/forget-password', { email }),
  changePassword: (payload) => apiClient.post('/profile/change-password', payload),
  createProfile: (payload) => apiClient.post('/profile', payload),
  updateNotifications: (notifications) => apiClient.put('/profile/notifications', notifications),
  verifyEmail: (token) => apiClient.post(`/profile/verify-email/${token}`),
  verifyEmailByAdmin: () => apiClient.post('/profile/verify-email-by-admin'),
  updateKYCFinished: (payload) => apiClient.put('/profile/on-kyc-finished', payload),
  requestEmailConfirmationCode: (email) => apiClient.put('/profile/change-email/request-code', { email }),
  changeEmail: (payload) => apiClient.put('/profile/change-email', payload),
  inviteTenant: (email) => apiClient.post('/profile/tenants', { email }),
  resendTenant: (tenantId, captcha) => apiClient.post(`/profile/tenants/${encodeURIComponent(tenantId)}/resend`, { captcha }),
  acceptTenantInvitation: (token, password) => apiClient.post('/profile/tenants/accept', { token, password }),
  removeTenant: (tenantId) => apiClient.delete(`/profile/tenants/${encodeURIComponent(tenantId)}`),
  reuqestEmailVerification: () => apiClient.put('/profile/request-email-verification'),
  adjustCredits: (amount) => apiClient.put('/profile/adjust-credits', { amount }),
  issueInvoice: (amount) => apiClient.put('/profile/issue-invoice', { amount }),
  voidInvoice: (invoiceId, comment) => apiClient.put('/profile/void-invoice', { invoiceId, comment }),
  saveTOSAgreement: (data) => apiClient.post('/profile/tos-agreement', data),
  fetchUserConfig: () => apiClient.get('/profile/partner-config'),
};
